import { Button, Flex, H1, useBreadcrumbs } from "@inmagik/magik-ui"
import Layout from "../../components/Layout"
import { Tag } from "../../types"
import { useNavigate, useParams } from "react-router-dom"
import { Formik } from "formik"
import { initialValuesTag, validationSchemaTag } from "./TagCommon"
import { Container } from "react-bootstrap"
import BottomFormFixed from "../../components/BottomFormFixed"
import useModalTrigger from "magik-react-hooks/useModalTrigger"
import ModalDelete from "../../components/ModalDelete"
import { useMemo } from "react"
import { useTag, useTagDelete, useTagUpdate } from "../../hooks/tags"
import TagForm from "./TagForm"
import { ScrollLayout } from "../../components/ScrollLayout"
import { transformErrorForForm } from "../../utils/utils"

export default function TagUpdate() {
  const updateTag = useTagUpdate()
  const navigate = useNavigate()

  const { id } = useParams()

  const { data: tag } = useTag(Number(id))

  const [modalStateDeleteTag, modalActionsDeleteTag] = useModalTrigger()

  const deleteTag = useTagDelete()

  const initialValues = useMemo(() => initialValuesTag(tag), [tag])
  const validationSchema = useMemo(() => validationSchemaTag(), [])

  useBreadcrumbs([{ label: "Tags", href: "/tags/tags" }, { label: "Dettaglio tag" }])

  return (
    <Layout>
      <ScrollLayout hasBottomFixed>
        <Flex alignItems="center" justifyContent="between">
          <H1>{tag?.nome}</H1>
          <Button
            size="md"
            variant="danger"
            title="Elimina"
            leadingIcon="delete"
            onClick={() => {
              modalActionsDeleteTag.open()
            }}
          />
        </Flex>
        <ScrollLayout.Scroll>
          <Formik
            enableReinitialize
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(values, actions) => {
              return updateTag.mutateAsync(values as Tag).then(() => {
                navigate(`/tags/tags`)
              }).catch((e) => {
                actions.setErrors(transformErrorForForm(e))
              })
            }}
          >
            {({ handleSubmit }) => (
              <form onSubmit={handleSubmit}>
                <Container fluid className="mt-6" style={{ marginBottom: "100px" }}>
                  <TagForm />
                </Container>
                <BottomFormFixed url="/tags/tags" />
              </form>
            )}
          </Formik>
        </ScrollLayout.Scroll>
      </ScrollLayout>
      <ModalDelete
        isOpen={modalStateDeleteTag.isOpen}
        onClose={modalActionsDeleteTag.close}
        onDelete={() => {
          return deleteTag.mutateAsync(tag?.id).then(() => {
            navigate(`/tags/tags`)
          })
        }}
        message="Sei sicuro di voler eliminare questo tag?"
        title="Elimina tag"
      />
    </Layout>
  )
}
